import * as moment from 'moment-timezone';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Dialog } from '../../ui/dialog/dialog';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { SLEntityFilter } from './entity.service';

type HasMovementsType = 'ANY' | 'YES' | 'NO';

/**
 * SLEntity filter dialog
 */
@Component({
  templateUrl: './entity-filter-dialog.component.html',
  host: {'(window:keydown)': 'hotkeys($event)'},
  styles: [
    `.dialog-container {
      display: block;
      position: fixed;
      z-index: 300;
      width: 100%;
      left: 0;
    }`
  ],
  animations: [
    trigger(
      'openState',
      [
        state(
          'open',
          style({
            top: '0px'
          })
        ),
        state(
          'closed',
          style({
            top: '-306px'
          })
        ),
        transition('closed => open', animate('400ms ease-out')),
        transition('open => closed', animate('400ms ease-in')),
      ]
    ),
  ]
})
export class SLEntityFilterDialogComponent implements Dialog, OnInit {
  state = 'closed';

  filter: SLEntityFilter

  lastSearch: string
  searchTimer: any

  @ViewChild('searchInput')
  searchInput: ElementRef

  hasMovements: HasMovementsType = 'ANY'
  orderBy = 'NAME/ASC'
  updateDate = 'ALL_TIME'

  HAS_MOVEMENTS_OPTIONS = [
    {
      id: 'ANY',
      text: '--'
    },
    {
      id: 'YES',
      text: 'Avec mouvements'
    },
    {
      id: 'NO',
      text: 'Sans mouvements'
    }
  ];

  ORDER_BY_OPTIONS = [
    {
      id: 'NAME/DESC',
      text: 'Nom ↓'
    },
    {
      id: 'NAME/ASC',
      text: 'Nom ↑'
    }
  ];

  UPDATE_DATE_OPTIONS = [
    {
      id: 'ALL_TIME',
      text: 'Tout le temps'
    },
    {
      id: 'LAST_30_DAYS',
      text: 'Les 30 derniers jours'
    }
  ]; 
  
  onClose: () => void
  onApply: (filter: SLEntityFilter) => void

  ngOnInit() {
    this.lastSearch = this.filter.search;

    if (this.filter.hasMovements === true) {
      this.hasMovements = 'YES';
    }
    else if (this.filter.hasMovements === false) {
      this.hasMovements = 'NO';
    }
    else {
      this.hasMovements = 'ANY';
    }

    this.orderBy = this.filter.orderBy + '/' + this.filter.orderDir;

    // if(this.filter.start_date !== '0') {
    //   this.updateDate = 'LAST_30_DAYS';
    // }
    // else {
    //   this.updateDate = 'ALL_TIME';
    // }

    // Focus search input
    this.searchInput.nativeElement.focus();
  }

  close() {
    this.onClose();
  }

  apply() {
    let [orderBy, orderDir] = this.orderBy.split('/');

    if(this.hasMovements === 'ANY') {
      this.filter.hasMovements = undefined;
    }
    else if (this.hasMovements === 'YES') {
      this.filter.hasMovements = true;
    }
    else if (this.hasMovements === 'NO') {
      this.filter.hasMovements = false;
    }

    if(orderBy === 'NAME') {
      this.filter.orderBy = orderBy;
    }

    if(orderDir === 'ASC' || orderDir === 'DESC') {
      this.filter.orderDir = orderDir;
    }

    // if(this.updateDate === 'ALL_TIME') {
    //   this.filter.start_date = '0';
    //   this.filter.end_date = '0';
    // }
    // else if(this.updateDate === 'LAST_30_DAYS') {
    //   this.filter.start_date = (moment.utc().add(-30, 'd').toDate().getTime()).toString();
    //   this.filter.end_date = '0';
    // }

    this.onApply(this.filter);
  }

  hotkeys(event: KeyboardEvent){

    switch(event.keyCode) {
      // Escape key
      case 27:
        this.close();
        break;
      // Enter key
      case 13:
        this.apply();
        this.close();
        break;
    }
  }

  searchKeyup(event: KeyboardEvent) {
    if(this.lastSearch !== this.filter.search) {
      this.lastSearch = this.filter.search;

      if(this.searchTimer) {
        window.clearTimeout(this.searchTimer);
      }

      this.searchTimer = window.setTimeout(() => {
        this.apply();
      }, 500);
    }
  }
}

